import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BusinessHoursDisplay } from "@/components/business/BusinessHoursDisplay";
import { Clock, ExternalLink, Globe, Mail, MapPin, MessageCircle, Phone } from "lucide-react";

type BusinessInfoCardProps = {
  phone?: string | null;
  email?: string | null;
  website?: string | null;
  kakaoId?: string | null;
  address?: string | null;
  city?: string | null;
  postcode?: string | null;
  hours?: unknown;
  googleMapsUrl?: string | null;
  googleMapsEmbedUrl?: string | null;
  onPhone: () => void;
  onWebsite: () => void;
  onDirections: () => void;
};

export function BusinessInfoCard(props: BusinessInfoCardProps) {
  const hasContact = props.phone || props.email || props.website || props.kakaoId;
  return (
    <Card>
      <CardHeader className="pb-3"><CardTitle className="text-lg">업체 정보</CardTitle></CardHeader>
      <CardContent className="space-y-5">
        {hasContact && <div className="space-y-1">
          {props.phone && <a href={`tel:${props.phone}`} onClick={props.onPhone} className="flex items-center gap-3 rounded-lg p-2 text-sm hover:bg-muted"><Phone className="h-4 w-4 text-muted-foreground" />{props.phone}</a>}
          {props.email && <a href={`mailto:${props.email}`} className="flex items-center gap-3 rounded-lg p-2 text-sm hover:bg-muted"><Mail className="h-4 w-4 text-muted-foreground" /><span className="break-all">{props.email}</span></a>}
          {props.website && <a href={props.website} target="_blank" rel="noopener noreferrer" onClick={props.onWebsite} className="flex items-center gap-3 rounded-lg p-2 text-sm hover:bg-muted"><Globe className="h-4 w-4 text-muted-foreground" /><span>홈페이지</span><ExternalLink className="ml-auto h-3 w-3" /></a>}
          {props.kakaoId && <div className="flex items-center gap-3 p-2 text-sm"><MessageCircle className="h-4 w-4 text-muted-foreground" />카카오톡: {props.kakaoId}</div>}
        </div>}

        {props.address && <div className="space-y-3 border-t pt-4">
          <div className="flex items-start gap-3 text-sm"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" /><div><p>{props.address}</p><p className="text-muted-foreground">{[props.city, props.postcode].filter(Boolean).join(" ")}</p></div></div>
          {props.googleMapsEmbedUrl && <button type="button" onClick={props.onDirections} className="block h-40 w-full overflow-hidden rounded-xl border text-left">
            <iframe src={props.googleMapsEmbedUrl} className="h-full w-full pointer-events-none" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="업체 위치" />
          </button>}
          {props.googleMapsUrl && <Button variant="outline" className="w-full" onClick={props.onDirections}><MapPin className="mr-2 h-4 w-4" />Google Maps에서 길찾기</Button>}
        </div>}

        {!!props.hours && <div className="space-y-3 border-t pt-4"><div className="flex items-center gap-2 font-medium"><Clock className="h-4 w-4" />영업시간</div><BusinessHoursDisplay hours={props.hours as any} /></div>}
      </CardContent>
    </Card>
  );
}
